import { store } from "../reducer/Store";
import Select from "react-select";
import React from "react";
const SelectBrands = ({
  brand,
  setBrand,
  isRequired = false,
  isFromFormUser = false,
  handleInputChange,
}) => {
  const { dispatch, state } = React.useContext(store);
  return (
    <Select
      placeholder="Marques"
      isMulti
      required={isRequired}
      value={brand}
      onChange={(e) => {
        if (window.location.href.includes("admin/rapport-visuel")) {
          // avoid display content before its ready to render in Visuel Rapport
          dispatch({ type: "SET_LOADER", payload: true });
        }

        /**
         * Si la valeur de 'isFromFormUser' est true, cela signifie que la fonction est appelée depuis un formulaire utilisateur.
         * Dans ce cas, la fonction vérifie si l'un des éléments de 'e' a une valeur égale à "all". Si c'est le cas, la fonction met à jour l'état 'brand' en utilisant une partie de 'state.listBrands' à partir de l'indice 1, et appelle la fonction 'handleInputChange' avec cette nouvelle valeur et le paramètre "brands".
         * Si aucun des éléments de 'e' n'a une valeur égale à "all", la fonction met à jour l'état 'brand' avec la valeur 'e' et appelle la fonction 'handleInputChange' avec cette valeur et le paramètre "brands".
         *
         * Si la valeur de 'isFromFormUser' est false, cela signifie que la fonction n'est pas appelée depuis un formulaire utilisateur.
         * Dans ce cas, la fonction effectue des actions similaires, mais en plus de mettre à jour l'état 'brand', elle enregistre également la valeur dans le localStorage en utilisant la clé "currentBrands" et met à jour le state 'currentBrands' avec la nouvelle valeur.
         */
        if (isFromFormUser) {
          if (e.some((elt) => elt.value === "all")) {
            setBrand(state.listBrands.slice(1));
            handleInputChange(state.listBrands.slice(1), "brands");
          } else {
            setBrand(e);
            handleInputChange(e, "brands");
          }
        } else {
          if (e.some((elt) => elt.value === "all")) {
            setBrand(state.listBrands.slice(1));
            localStorage.setItem(
              "currentBrands",
              JSON.stringify(state.listBrands.slice(1))
            );
            dispatch({
              type: "SET_CURRENTBRANDS",
              payload: state.listBrands.slice(1),
            });
          } else {
            setBrand(e);
            localStorage.setItem("currentBrands", JSON.stringify(e));
            dispatch({
              type: "SET_CURRENTBRANDS",
              payload: e,
            });
          }
        }
      }}
      name="brands"
      options={state.listBrands}
      className="bg-blue-light black border-white marque-selector"
    />
  );
};

export default SelectBrands;
